import { environment } from 'src/environments/environment';

export class BackendConstants {

  private static readonly _URL_ENDPOINT_BACKEND_PROD = 'https://selfcare.virginmobile.co/api'; // BSSPROD
  // private static readonly _URL_ENDPOINT_BACKEND_DEVEL = 'https://dev-mi.virginmobile.co/api'; // VMLATEST
  private static readonly _URL_ENDPOINT_BACKEND_DEVEL = 'https://8669vrecre.execute-api.us-east-1.amazonaws.com/dev/api'; // VMLATEST
  // private static readonly _URL_ENDPOINT_BACKEND_DEVEL = 'https://localhost:3002/dev/api'; // local


  private static readonly _URL_ENDPOINT_BACKEND_SECURE_PROD = 'https://selfcare.virginmobile.co/apisec/api'; // BSSPROD
  // private static readonly _URL_ENDPOINT_BACKEND_SECURE_DEVEL = 'https://dev-mi.virginmobile.co/apisec/api'; // VMLATEST
  private static readonly _URL_ENDPOINT_BACKEND_SECURE_DEVEL = 'https://5rs2qe08g1.execute-api.us-east-1.amazonaws.com/dev/api'; // VMLATEST
  // private static readonly _URL_ENDPOINT_BACKEND_SECURE_DEVEL = 'https://localhost:3003/dev/api'; // MBTEST


  public static get URL_ENDPOINT_BACKEND(): string {
    return environment.production
      ? BackendConstants._URL_ENDPOINT_BACKEND_PROD + '/v1'
      : BackendConstants._URL_ENDPOINT_BACKEND_DEVEL + '/v1';
  }

  public static get URL_ENDPOINT_BACKEND_SECURE(): string {
    return environment.production
      ? BackendConstants._URL_ENDPOINT_BACKEND_SECURE_PROD + '/v1'
      : BackendConstants._URL_ENDPOINT_BACKEND_SECURE_DEVEL + '/v1';
  }

  public static get URL_ENDPOINT_BACKEND_SECURE_BASE(): string {
    return environment.production
      ? BackendConstants._URL_ENDPOINT_BACKEND_SECURE_PROD
      : BackendConstants._URL_ENDPOINT_BACKEND_SECURE_DEVEL;
  }

  public static get URL_ENDPOINT_BACKEND_SECURE_V2(): string {
    return environment.production
      ? BackendConstants._URL_ENDPOINT_BACKEND_SECURE_PROD + '/v2'
      : BackendConstants._URL_ENDPOINT_BACKEND_SECURE_DEVEL + '/v2';
  }

}
